export const capitalizeFirstLetter = (text) =>
  text && typeof text === 'string'
    ? `${text.charAt(0).toUpperCase()}${text.slice(1)}`
    : '';

export const removeHTMLTags = (string) => string.replace(/<[^>]+>/g, '');
